const product = {
  product: "Produk", // translated 
  products: "Produk", // translated 
  information: "Informasi", // translated 
  additionalInformation: "informasi tambahan", // translated 
  contactUs: "Hubungi kami", // translated 
  contactUsText: "Ingin menyesuaikan tur Anda atau memiliki pertanyaan lain?", // translated 
  dropUsAnEmail: "Kirimi kami email", // translated 
  viewLess: "Lihat lebih sedikit", // translated 
  viewMore: "Lihat lebih banyak", // translated 
  less: "lebih sedikit", // translated 
  more: "lagi", // translated 
  highlights: "Highlight", // translated 
  inclusions: "Inklusi", // translated 
  exclusions: "Pengecualian", // translated 
  pleaseWait: "Harap tunggu...", // translated 
  tourType: "Jenis Tur", // translated 
  search: "Mencari", // translated 
  available: "Tersedia", // translated 
  availableTours: "Tur yang Tersedia", // translated 
  sortBy: "SORTIR DENGAN", // translated 
  priceLowToHigh: "Harga: Rendah ke Tinggi", // translated 
  priceHighToLow: "Harga: Tinggi ke Rendah", // translated 
  mostPopular: "Paling Populer", // translated 
  roomOnly: "Kamar Saja", // translated 
  bedAndBreakfast: "Tempat Tidur & Sarapan", // translated 
  halfBoard: "Setengah papan", // translated 
  fullBoard: "Lengkap", // translated 
  allInclusive: "Semua Termasuk", // translated 
  viewDetails: "Melihat rincian", // translated 
  close: "Menutup", // translated 
  at: "Pada", // At dat, // translated 
  person: "orang", // translated 
  cancellationPolicy: "Kebijakan Pembatalan", // translated 
  cancellationIs: "pembatalan adalah", // translated 
  to: "Ke", // translated 
  bookingRemarks: "Keterangan Pemesanan", // translated 
  totalPrice: "Total harga", // translated 
  back: "Kembali", // translated 
  bookNow: "Pesan sekarang", // translated 
  minutes: "Menit", // translated 
  visitDuration: "Durasi Kunjungan", // translated 
  itinerary: "Rencana perjalanan", // translated 
  airportToHotel: "Bandara ke Hotel", // translated 
  hotelToAirport: "Hotel ke Bandara", // translated 
  details: "detail", // translated 
  servicesDetails: "Detail Layanan", // translated 
  services: "Jasa", // translated 
  day: "Hari", // translated 
  next: "Berikutnya", // translated 
  nextStep: "Langkah berikutnya", // translated 
  skip: "Melewati", // translated 
  remarks: "Perkataan", // translated 
  optional: "opsional", // translated 
  guests: "Tamu", // translated 
  payment: "Pembayaran", // translated 
  pickup: "menjemput", // translated 
  featuredPackage: "Paket Unggulan", // translated 
  flights: "Penerbangan", // translated 
  accommodation: "Akomodasi", // translated 
  transfers: "Transfer", // translated 
  tours: "Tur", // translated 
  experiences: "Pengalaman", // translated 
  featuredTour: "Tur Unggulan", // translated 
  From: "Dari", // translated 
  Accommodation: "Akomodasi", // translated 
  approxDuration: "Kira-kira. durasi", // translated 
  travellerInformation: "Informasi Wisatawan", // translated 
  bookingOverview: "Ikhtisar Pemesanan", // translated 
  checkout: "Periksa", // translated 
  paymentFailed: "Pembayaran gagal", // translated 
  paymentSuccess: "pembayaran berhasil", // translated 
  night: "Malam", // translated 
  nights: "malam", // translated 
  viewEscapes: "Lihat Pelarian", // translated 
  viewExperience: "Lihat Pengalaman", // translated 
  escapeType: "Tipe Pelarian", // translated 
  adultsOnly: "Hanya untuk orang dewasa", // translated 
  totalDuration: "Durasi total", // translated 
  options: "Pilihan", // translated 
  departingAirport: "Keberangkatan Bandara", // translated 
  childrenAreNotAllowedInThisTour: "Anak-anak tidak diperbolehkan mengikuti tur ini", // translated 
};


export default product;
